module.exports = {"TXTWCL_Just_so_you_know":{"id":"TXTWCL_Just_so_you_know","defaultMessage":"Per tua informazione","track":"Just so you know"}}